export default {
  getNameMonthByDate(date) {
    let month = new Date(date).getMonth()
    return getNameMonthByMonth(month)
  },
  getShortNameMonthByDate(date) {
    let month = new Date(date).getMonth()
    return getShortNameMonthByMonth(month)
  },
  getNameMonthByMonth(month) {
    let monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]
    return monthNames[month]
  },
  getShortNameMonthByMonth(month) {
    let monthNamesShort = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]

    return monthNamesShort[month]
  },
  getPosition(options) {
    return new Promise(function(resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject, options)
    })
  },
}



// WEBPACK FOOTER //
// ./src/services/helper.js